(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["a-hp-collection-tabs"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-hp-collection-tabs')) {
		class LTAHPCollectionTabs extends HTMLElement {
			constructor() {
				super()

				this.handleTabClick = this.handleTabClick.bind(this)
			}

			connectedCallback() {
				this.tabEls = this.querySelectorAll('[data-tab-button]')
				this.productTabsEls = this.querySelectorAll('[data-products]')

				this.tabEls.forEach((tabEl) => {
					tabEl.addEventListener('click', this.handleTabClick)
				})
			}

			disconnectedCallback() {
				if (this.tabEls) {
					this.tabEls.forEach((tabEl) => {
						tabEl.removeEventListener('click', this.handleTabClick)
					})
				}
			}

			handleTabClick(event) {
				const tabEl = event.currentTarget
				if (!tabEl) return
				const blockId = tabEl.getAttribute('data-tab-button')

				this.toggleProductTabs(blockId)
			}

			toggleProductTabs(blockId) {
				if (!blockId) return

				this.tabEls.forEach((tabEl) => {
					const isActive = tabEl.getAttribute('data-tab-button') === blockId
					tabEl.classList.toggle('is-active', isActive)
				})

				this.productTabsEls.forEach((productTabEl) => {
					const productBlockId = productTabEl.getAttribute('data-products')
					productTabEl.classList.toggle('l-hidden', productBlockId !== blockId)
				})
			}
		}

		customElements.define('l-hp-collection-tabs', LTAHPCollectionTabs)
	}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["a-stix-sticky-bar"] && !Shopify.designMode) return;
  try {
    
	if (!customElements.get('l-stix-sticky-bar')) {
		class LStixStickyBar extends HTMLElement {
			constructor() {
				super()
				this.handleScroll = this.handleScroll.bind(this)
			}

			connectedCallback() {
				this.handleScroll()
				window.addEventListener('scroll', this.handleScroll, { passive: true })
			}

			disconnectedCallback() {
				window.removeEventListener('scroll', this.handleScroll)
			}

			handleScroll() {
				const shouldShow = window.scrollY > 300
				this.parentElement.classList.toggle('is-visible', shouldShow)
			}
		}

		customElements.define('l-stix-sticky-bar', LStixStickyBar)
	}

  } catch(e) { console.error(e); }
})();
})();
